<template>
  <pb-drawer :visible.sync="open" :append-to-body="true" size="400px" class="feedback-card-detail">
    <template #title>
      <div>
        <img class="feedback-info-back" :src="require('../assets/back.svg')" @click="back" />
        <span>{{ $t('Gattaran_Feedback__pbpG' /** 反馈详情 */) }}</span>
      </div>
    </template>
    <ProcessFlow :data="data" :loading="isFlowLoading" />
    <FeedbackInfo :data="data" :loading="isInfoLoading" />
  </pb-drawer>
</template>

<script>
import ProcessFlow from './process-flow.vue';
import FeedbackInfo from './feedback-info.vue';
export default {
  components: {
    ProcessFlow,
    FeedbackInfo,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      open: false,
      isFlowLoading: false,
      isInfoLoading: false,
      infos: {},
    };
  },
  methods: {
    back() {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-info-back {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: middle;
  cursor: pointer;
}
:deep(.feedback-card-detail) {
  .pb-drawer__header {
    height: 56px;
    margin-bottom: 0;
    border-bottom: 1px solid #e9eaee;
    box-sizing: border-box;
    padding: 16px 12px 16px 16px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 16px;
    color: #282b33;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 500;
  }

  .pb-drawer__close-btn {
    font-size: 16px;
    margin-right: -6px;
  }
}
</style>
